import { PayloadAction } from '@reduxjs/toolkit';
import dotPropImmutable from 'dot-prop-immutable';
import { RevenueRecognitionActionPayload } from '../actions';
import { ProjectTemplateStore } from '../types';

// DEAD CODE - Todo @Muskaan- remove this

export const revenueRecognitionSlice = {
  updateRecognitionConfigAction: (
    state: ProjectTemplateStore,
    {
      payload: { milestoneRevenueRecognitionConfigs },
    }: PayloadAction<RevenueRecognitionActionPayload>,
  ): ProjectTemplateStore => {
    const path = `data.${state.activeId}.milestoneRevenueRecognitionConfigs`;

    const recognitionConfig = milestoneRevenueRecognitionConfigs.filter(
      (item) => item.recognisedPercentage,
    );

    return dotPropImmutable.set(state, path, recognitionConfig);
  },
};
